const pannellum = [
  {
    level: '1-3',
    image: require('src/assets/images/views/5.jpg'),
  },
  {
    level: '4-6',
    image: require('src/assets/images/views/6.jpg'),
  },
  {
    level: '7-8',
    image: require('src/assets/images/views/9.jpg'),
  },
  {
    level: '9-10',
    image: require('src/assets/images/views/12.jpg'),
  },
  {
    level: '11-13',
    image: require('src/assets/images/views/15.jpg'),
  },
  {
    level: '14-16',
    image: require('src/assets/images/views/18.jpg'),
  },
  {
    level: '17-19',
    image: require('src/assets/images/views/21.jpg'),
  },
  {
    level: '19-21',
    image: require('src/assets/images/views/24.jpg'),
  },
  {
    level: '21-23',
    image: require('src/assets/images/views/28.jpg'),
  },
  {
    level: '23-25',
    image: require('src/assets/images/views/30.jpg'),
  },
  {
    level: '25-27',
    image: require('src/assets/images/views/31.jpg'),
  },
  {
    level: '27-30',
    image: require('src/assets/images/views/32.jpg'),
  },
  {
    level: '30-33',
    image: require('src/assets/images/views/33.jpg'),
  },
];

export default pannellum;


// WEBPACK FOOTER //
// ./src/data/pannellum.js